import FilterOutlineIcon from '@eduzz/houston-icons/FilterOutline';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import moment from 'moment';
import React from 'react';
import { isInclusivelyBeforeDay } from 'react-dates';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectAffiliate } from 'v2/components/Shared/FormFields/SelectAffiliate';
import { affiliateCommissionsService, initialFilter } from 'v2/services/reports/affiliateCommissions';

import type { IAffiliateCommissionFilter } from 'v2/interfaces/reports/affiliateCommissions';

import { useStyles } from './styles';

import type { Moment } from 'moment';

export const Form = () => {
  const classes = useStyles();

  const { isValid, isSubmitting, resetForm, dirty } = useFormikContext<IAffiliateCommissionFilter>();

  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Moment) => !isInclusivelyBeforeDay(day, moment());

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const isCleanDisabled = !dirty || isSubmitting || isLoading;
  const isFilterDisabled = !isValid || isSubmitting || isLoading;

  return (
    <FormikForm>
      <div id='commissions-paid-to-affiliates' className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Field label='Período' id='date' name='date' component={DateRangePickerFormField} isPresetLonger isOutsideRange={isOutsideRange} />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <Field
              id='affiliates'
              name='affiliates'
              label='Afiliados'
              placeholder='Selecione o(s) afiliado(s)'
              component={SelectAffiliate}
              fullWidth
            />
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button id='clean-filter-button' onClick={handleClean} variant='text' fullWidth disabled={isCleanDisabled}>
            Limpar
          </Button>
          <Button
            id='filter-button'
            variant='contained'
            disabled={isFilterDisabled}
            type='submit'
            fullWidth
            startIcon={
              isSubmitting || isLoading ? <CircularProgress size={20} color='inherit' /> : <FilterOutlineIcon className={classes.filterIcon} />
            }
            color='primary'
          >
            Filtrar
          </Button>
        </div>
      </div>
    </FormikForm>
  );
};
